<i nz-icon nzType="question-circle" nzTheme="twotone" nz-tooltip nzTwotoneColor="#FF5500" [nzTooltipTitle]="tooltipText"></i>
